function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { PureComponent } from 'react';
import Slide from "@mui/material/Slide";
import { helpers } from '@simplybenefits/sb-utils';
import Modal from '../../components/Modals/Modal.js';
import MessageCard from '../../components/Cards/MessageCard.js';
import Text from '../../components/Text.js';
import Bubble from '../../components/Bubble.js';
import Tooltip from '../../components/Tooltip.js';
import ContainerControlSite from '../../components/Divs/ContainerControlSite.js';
import ClassPricingContainer from './ClassPricingContainer.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
class Pricing extends PureComponent {
  state = {
    classIDs: helpers.sortObjByTitle(this.props.classData),
    selectedClassID: null,
    showSubmitPricingDialog: false
  };

  // eslint-disable-next-line react/display-name
  _transition = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Slide, _extends({
    direction: "up",
    ref: ref
  }, props)));
  _selectClass = selectedClassID => {
    this.setState({
      selectedClassID
    });
  };

  // eslint-disable-next-line consistent-return
  _submitPricing = async () => {
    const success = await this.props.submitPricing(this.props.currentAccountMeta.accountID);
    if (success) {
      if (this.props.isRevision) {
        this.props.setSelectedSection('revision-assign-plans');
        return null;
      }
      this.setState({
        showSubmitPricingDialog: false
      });
    }
  };
  _goBack = () => {
    this.setState({
      selectedClassID: null
    });
  };
  render() {
    const {
      classes
    } = this.props;
    if (this.state.selectedClassID) {
      return /*#__PURE__*/React.createElement(ClassPricingContainer, {
        selectedClass: this.props.classData[this.state.selectedClassID],
        selectedClassID: this.state.selectedClassID,
        quote: this.props.quote,
        isQuote: this.props.isQuote,
        isRevision: this.props.isRevision,
        classData: this.props.classData,
        designs: this.props.designs,
        commissions: this.props.commissions,
        currentAccountMeta: this.props.currentAccountMeta,
        isMasterSite: this.props.isMasterSite,
        submitPricing: this.props.submitPricing,
        savePricingInput: this.props.savePricingInput,
        savePricing: this.props.savePricing,
        saveTelusDrugPlanID: this.props.saveTelusDrugPlanID,
        getPricingRevisions: this.props.getPricingRevisions,
        getSinglePricingRevision: this.props.getSinglePricingRevision,
        saveCoverages: this.props.saveCoverages,
        goBack: this._goBack,
        loader: this.props.loader,
        whitelabel: this.props.whitelabel
      });
    }
    return /*#__PURE__*/React.createElement(ContainerControlSite, {
      id: "account-pricing"
    }, /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.titles.pricing),
      subtitle: i18n.t(tokens.labels.planDesign.reviewAndSetPricing),
      btn: this.props.quote && this.props.currentAccountMeta.state <= 4 || this.props.isRevision && this.props.step <= 2,
      btnName: i18n.t(tokens.buttons.submit),
      btnOnClick: () => {
        if (this.props.isRevision) {
          this._submitPricing();
        } else {
          this.setState({
            showSubmitPricingDialog: true
          });
        }
      }
    }), this.state.classIDs.map(classID => {
      const data = this.props.classData[classID];

      // if it's modular flex then we don't want to show the parent classes, only the flex classes
      if (data.isModular && data.parentClassID === null) {
        return null;
      }
      return data.description ? /*#__PURE__*/React.createElement(Tooltip, {
        tip: data.description,
        placement: "top",
        arrow: true,
        display: "inline-block",
        key: classID
      }, /*#__PURE__*/React.createElement(Bubble, {
        label: `${i18n.t(tokens.titles.class)}: ${data.title}`,
        isSelected: true,
        onClick: () => this._selectClass(classID),
        clickable: true,
        customStyle: {
          marginLeft: "5px",
          marginRight: "5px"
        }
      })) : /*#__PURE__*/React.createElement(Bubble, {
        key: classID,
        label: `${i18n.t(tokens.titles.class)}: ${data.title}`,
        isSelected: true,
        onClick: () => this._selectClass(classID),
        clickable: true,
        customStyle: {
          marginLeft: "5px",
          marginRight: "5px"
        }
      });
    }), /*#__PURE__*/React.createElement(Modal, {
      open: this.state.showSubmitPricingDialog,
      onClose: () => {
        this.setState({
          showSubmitPricingDialog: false
        });
      },
      title: i18n.t(tokens.titles.areYouSure),
      primaryButton: {
        label: i18n.t(tokens.buttons.continue),
        onClick: this._submitPricing
      },
      loader: this.props.loader
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.planDesign.clickAcceptPricing))));
  }
}
export default Pricing;